export const PERMISSIONS_API_URL = 'anonym/permission/list';

export const PERMISSIONS_QUERY_KEY = 'permissions';

export const PermissionsList = {
  admin: {
    ADMINFEES_DELETE: 'api2.admin.adminfeescontroller.delete',
    ADMINFEES_EDIT: 'api2.admin.adminfeescontroller.edit',
    ADMINGROUPS_DELETE: 'api2.admin.admingroupscontroller.delete',
    ADMINGROUPS_EDIT: 'api2.admin.admingroupscontroller.edit',
    ADMINGROUPS_SHOW: 'api2.admin.admingroupscontroller.show',
    AFFILIATECASHOUTS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY_DOWNLOAD:
      'api2.admin.affiliatecashoutscontroller.admin_balance_adjustments_history_download',
    AFFILIATECASHOUTS_ADMIN_BALANCE_ADJUSTMENTS_HISTORY_SHOW:
      'api2.admin.affiliatecashoutscontroller.admin_balance_adjustments_history_show',
    AFFILIATECASHOUTS_AFFILIATES_BALANCES_DOWNLOAD:
      'api2.admin.affiliatecashoutscontroller.affiliates_balances_download',
    AFFILIATECASHOUTS_AFFILIATES_BALANCES_EDIT: 'api2.admin.affiliatecashoutscontroller.affiliates_balances_edit',
    AFFILIATECASHOUTS_AFFILIATES_BALANCES_SHOW: 'api2.admin.affiliatecashoutscontroller.affiliates_balances_show',
    AFFILIATECASHOUTS_PENDING_WITHDRAWALS_DOWNLOAD:
      'api2.admin.affiliatecashoutscontroller.pending_withdrawals_download',
    AFFILIATECASHOUTS_PENDING_WITHDRAWALS_EDIT: 'api2.admin.affiliatecashoutscontroller.pending_withdrawals_edit',
    AFFILIATECASHOUTS_PENDING_WITHDRAWALS_SHOW: 'api2.admin.affiliatecashoutscontroller.pending_withdrawals_show',
    AFFILIATECASHOUTS_WITHDRAWALS_CREATE: 'api2.admin.affiliatecashoutscontroller.withdrawals_create',
    AFFILIATECASHOUTS_WITHDRAWALS_HISTORY_DOWNLOAD:
      'api2.admin.affiliatecashoutscontroller.withdrawals_history_download',
    AFFILIATECASHOUTS_WITHDRAWALS_HISTORY_SHOW: 'api2.admin.affiliatecashoutscontroller.withdrawals_history_show',
    AFFILIATEINVITATIONS_EDIT: 'api2.admin.affiliateinvitationscontroller.edit',
    AFFILIATES_CHANGE_BAN_STATUS: 'api2.admin.affiliatescontroller.change_ban_status',
    AFFILIATES_CHANGE_MANAGER_FOR_AFFILIATES: 'api2.admin.affiliatescontroller.change_manager_for_affiliates',
    AFFILIATES_DOWNLOAD_LIST_APPROVED: 'api2.admin.affiliatescontroller.download_list_approved',
    AFFILIATES_DOWNLOAD_LIST_REQUESTS_HISTORY: 'api2.admin.affiliatescontroller.download_list_requests_history',
    AFFILIATES_EDIT: 'api2.admin.affiliatescontroller.edit',
    AFFILIATES_CHANGE_TRACKER_COUNTRY: 'api2.admin.affiliatescontroller.change_tracker_country',
    AFFILIATES_MASS_CHANGE_TRACKER_COUNTRY: 'api2.admin.affiliatescontroller.mass_change_tracker_country',
    AFFILIATES_PENDING_AFFILIATES: 'api2.admin.affiliatescontroller.pending_affiliates',
    AFFILIATES_REQUEST: 'api2.admin.affiliatescontroller.request',
    AFFILIATES_SELECT_MANAGER: 'api2.admin.affiliatescontroller.select_manager',
    AFFILIATES_UPDATE_DEPARTMENT: 'api2.admin.affiliatescontroller.update_department',
    AFFILIATES_SHOW: 'api2.admin.affiliatescontroller.show',
    AFFILIATES_SUPERVISION: 'api2.admin.affiliatescontroller.supervision',
    AFFILIATES_UNCONFIRMED_EMAIL: 'api2.admin.affiliatescontroller.unconfirmed_email',
    AFFILIATES_WITHDRAW_FROM_STATUS_DENIED: 'api2.admin.affiliatescontroller.withdraw_from_status_denied',
    AFFILIATES_CLEAR_GOOGLE_SECRET: 'api2.admin.affiliatescontroller.clear_google_secret',
    AFFILIATES_CHANGE_NNCO_FOR_AFFILIATES: 'api2.admin.affiliatescontroller.change_nnco_for_affiliates',
    AFFILIATES_CHANGE_TRAFFIC_SOURCE: 'api2.admin.affiliatescontroller.update_traffic_source',
    AFFILIATES_UPDATE_COUNTRY: 'api2.admin.affiliatescontroller.update_country',
    APITOKENSREFRESH_EDIT: 'api2.admin.apitokensrefreshcontroller.edit',
    APITOKENSREFRESH_SHOW: 'api2.admin.apitokensrefreshcontroller.show',
    ARTICLES_CREATE: 'api2.admin.articlescontroller.create',
    ARTICLES_DESTROY: 'api2.admin.articlescontroller.destroy',
    ARTICLES_SHOW: 'api2.admin.articlescontroller.show',
    ARTICLES_UPDATE: 'api2.admin.articlescontroller.update',
    AUTOAPPROVELOCALES_EDIT: 'api2.admin.autoapprovelocalescontroller.edit',
    AUTOAPPROVELOCALES_SHOW: 'api2.admin.autoapprovelocalescontroller.show',
    BACKGROUNDREPORTS_EDIT: 'api2.admin.backgroundreportscontroller.edit',
    BACKGROUNDREPORTS_SHOW: 'api2.admin.backgroundreportscontroller.show',
    BANKTRANSFERCOUNTRYGROUPS_EDIT: 'api2.admin.banktransfercountrygroupscontroller.edit',
    BANKTRANSFERCOUNTRYGROUPS_SHOW: 'api2.admin.banktransfercountrygroupscontroller.show',
    BANNERSETTINGS_DELETE: 'api2.admin.bannersettingscontroller.delete',
    BANNERSETTINGS_EDIT: 'api2.admin.bannersettingscontroller.edit',
    BANNERSETTINGS_SHOW: 'api2.admin.bannersettingscontroller.show',
    BONUSES_CREATE: 'api2.admin.bonusescontroller.create',
    BONUSES_DELETE: 'api2.admin.bonusescontroller.delete',
    BONUSES_EDIT: 'api2.admin.bonusescontroller.edit',
    BONUSES_SHOW: 'api2.admin.bonusescontroller.show',
    BOOKKEEPINGS_CHANGE_STATUS_MONTH_PAYMENT: 'api2.admin.bookkeepingscontroller.change_status_month_payment',
    BOOKKEEPINGS_DEDUCTION: 'api2.admin.bookkeepingscontroller.deduction',
    BOOKKEEPINGS_DOWNLOAD_REPORT: 'api2.admin.bookkeepingscontroller.download_report',
    BOOKKEEPINGS_SHOW: 'api2.admin.bookkeepingscontroller.show',
    BOOKKEEPINGS_TRANSFER_PAYMENT: 'api2.admin.bookkeepingscontroller.transfer_payment',
    BOOKKEEPINGS_TRANSFER_PAYOFF: 'api2.admin.bookkeepingscontroller.transfer_payoff',
    CLICKDOMAINS_EDIT: 'api2.admin.clickdomainscontroller.edit',
    CLICKDOMAINS_SHOW: 'api2.admin.clickdomainscontroller.show',
    CONDITIONS_DELETE: 'api2.admin.conditionscontroller.delete',
    CONDITIONS_EDIT: 'api2.admin.conditionscontroller.edit',
    CONDITIONS_SHOW: 'api2.admin.conditionscontroller.show',
    COUNTRIES_LIST: 'api2.admin.countriescontroller.list',
    CREATIVEREPORTS_DOWNLOAD_REPORT: 'api2.admin.creativereportscontroller.download_report',
    CREATIVEREPORTS_GENERATE_REPORT: 'api2.admin.creativereportscontroller.generate_report',
    CREATIVES_ACTIVE_OR_INACTIVE_CREATIVES: 'api2.admin.creativescontroller.active_or_inactive_creatives',
    CREATIVES_ARCHIVATION_CREATIVES: 'api2.admin.creativescontroller.archivation_creatives',
    CREATIVES_CREATE: 'api2.admin.creativescontroller.create',
    CREATIVES_EDIT: 'api2.admin.creativescontroller.edit',
    CREATIVES_SHOW: 'api2.admin.creativescontroller.show',
    CSVREPORTS_CREATE: 'api2.admin.csvreportscontroller.create',
    CLICK_DOMAINS_WELL_KNOWNS_SHOW: 'api2.admin.clickdomainswellknownscontroller.show',
    CLICK_DOMAINS_WELL_KNOWNS_EDIT: 'api2.admin.clickdomainswellknownscontroller.edit',
    DASHBOARD_CHART: 'api2.admin.dashboardcontroller.chart',
    DASHBOARD_GET_STATS: 'api2.admin.dashboardcontroller.get_stats',
    DASHBOARD_LAST_UPDATE: 'api2.admin.dashboardcontroller.last_update',
    DASHBOARD_TOPS: 'api2.admin.dashboardcontroller.tops',
    FILTERSETS_SHOW: 'api2.admin.filtersetscontroller.show',
    FTPFILES_SHOW: 'api2.admin.ftpfilescontroller.show',
    HISTORYOFLIMITCHANGES_CREATE: 'api2.admin.historyoflimitchangescontroller.create',
    HISTORYOFLIMITCHANGES_DELETE: 'api2.admin.historyoflimitchangescontroller.delete',
    HISTORYOFLIMITCHANGES_EDIT: 'api2.admin.historyoflimitchangescontroller.edit',
    HISTORYOFSUBAFFILIATESCHANGES_CREATE: 'api2.admin.historyofsubaffiliateschangescontroller.create',
    HISTORYOFSUBAFFILIATESCHANGES_DELETE: 'api2.admin.historyofsubaffiliateschangescontroller.delete',
    HISTORYOFSUBAFFILIATESCHANGES_EDIT: 'api2.admin.historyofsubaffiliateschangescontroller.edit',
    HISTORYOFTRACKERSCHANGES_DELETE: 'api2.admin.historyoftrackerschangescontroller.delete',
    HISTORYOFTRACKERSCHANGES_EDIT: 'api2.admin.historyoftrackerschangescontroller.edit',
    HISTORY_OF_FIXED_PAYMENTS_CHANGES_DELETE: 'api2.admin.historyoffixedpaymentschangescontroller.delete',
    HISTORY_OF_FIXED_PAYMENTS_CHANGES_EDIT: 'api2.admin.historyoffixedpaymentschangescontroller.edit',
    HISTORY_OF_NNCO_CHANGES_CHANGES_CREATE: 'api2.admin.historyofnncoschangescontroller.create',
    HISTORY_OF_NNCO_CHANGES_CHANGES_EDIT: 'api2.admin.historyofnncoschangescontroller.edit',
    HISTORY_OF_NNCO_CHANGES_CHANGES_DELETE: 'api2.admin.historyofnncoschangescontroller.delete',
    HISTORY_OF_TRACKER_GROUPS_CHANGES_SHOW: 'api2.admin.historyoftrackergroupschangescontroller.show',
    HISTORY_OF_TRACKER_GROUPS_CHANGES_CREATE: 'api2.admin.historyoftrackergroupschangescontroller.create',
    HISTORY_OF_TRACKER_GROUPS_CHANGES_EDIT: 'api2.admin.historyoftrackergroupschangescontroller.edit',
    HISTORY_OF_TRACKER_GROUPS_CHANGES_DELETE: 'api2.admin.historyoftrackergroupschangescontroller.delete',
    HISTORY_OF_ADMIN_FEES_CHANGES_SHOW: 'api2.admin.historyofadminfeeschangescontroller.show',
    HISTORY_OF_ADMIN_FEES_CHANGES_CREATE: 'api2.admin.historyofadminfeeschangescontroller.create',
    HISTORY_OF_ADMIN_FEES_CHANGES_EDIT: 'api2.admin.historyofadminfeeschangescontroller.edit',
    HISTORY_OF_ADMIN_FEES_CHANGES_DELETE: 'api2.admin.historyofadminfeeschangescontroller.delete',
    MAILERSMANAGER_EDIT: 'api2.admin.mailersmanagercontroller.edit',
    MAILING_ALL: 'api2.admin.mailingcontroller.all',
    MASSRETAG_RETAG: 'api2.admin.massretagcontroller.retag',
    MIRRORS_CREATE: 'api2.admin.mirrorscontroller.create',
    MIRRORS_DELETE: 'api2.admin.mirrorscontroller.delete',
    MIRRORS_EDIT: 'api2.admin.mirrorscontroller.edit',
    MIRRORS_SHOW: 'api2.admin.mirrorscontroller.show',
    NOTIFICATIONS_SHOW: 'api2.admin.notificationscontroller.show',
    OBSERVINGOFDAILYSTATISTICSPLAYERS_DOWNLOAD_LIST:
      'api2.admin.observingofdailystatisticsplayerscontroller.download_list',
    OBSERVINGOFDAILYSTATISTICSPLAYERS_SHOW: 'api2.admin.observingofdailystatisticsplayerscontroller.show',
    OBSERVINGOFDAILYSTATISTICSPLAYERS_TRACKERS: 'api2.admin.observingofdailystatisticsplayerscontroller.trackers',
    PAYMENTSYSTEMLISTS_SHOW: 'api2.admin.paymentsystemlistscontroller.show',
    PAYMENTSYSTEMLISTS_UPDATE: 'api2.admin.paymentsystemlistscontroller.update',
    PAYMENTSYSTEMS_SHOW: 'api2.admin.paymentsystemscontroller.show',
    PAYMENTSYSTEMS_UPDATE: 'api2.admin.paymentsystemscontroller.update',
    EDIT_PAYMENT_METHOD: 'api2.admin.paymentsystemscontroller.edit_payment_method',
    PAYMENTSYSTEMS_PENDING_LIST_SHOW: 'api2.admin.paymentchangeformspendingcontroller.show',
    PAYMENTSYSTEMS_HISTORY_LIST_SHOW: 'api2.admin.paymentchangeformshistorycontroller.show',
    PAYMENTSYSTEMS_DOWNLOAD_PENDING_LIST: 'api2.admin.paymentchangeformspendingcontroller.download_list',
    PAYMENTSYSTEMS_DOWNLOAD_HISTORY_LIST: 'api2.admin.paymentchangeformshistorycontroller.download_list',
    PERSONALS_CHANGE_BAN_STATUS: 'api2.admin.personalscontroller.change_ban_status',
    PERSONALS_CREATE: 'api2.admin.personalscontroller.create',
    PERSONALS_EDIT: 'api2.admin.personalscontroller.edit',
    PERSONALS_SHOW: 'api2.admin.personalscontroller.show',
    PERSONALS_CLEAR_GOOGLE_SECRET: 'api2.admin.personalscontroller.clear_google_secret',
    PROFILE_API_TOKENS: 'api2.admin.profilecontroller.api_tokens',
    PROFILE_EDIT: 'api2.admin.profilecontroller.edit',
    PROJECTSETTINGS_ADMINS_WITH_FULL_STATS_ACCESS: 'api2.admin.projectsettingscontroller.admins_with_full_stats_access',
    PROJECTSETTINGS_DEFAULT_ORDER_COLUMNS: 'api2.admin.projectsettingscontroller.default_order_columns',
    PROJECTSETTINGS_EDIT: 'api2.admin.projectsettingscontroller.edit',
    PROJECTSETTINGS_REPORT_FIELDS: 'api2.admin.projectsettingscontroller.report_fields',
    PROJECTSETTINGS_REQUIRED_FIELDS_IN_PROFILE_UPDATE:
      'api2.admin.projectsettingscontroller.required_fields_in_profile_update',
    PROMOCODES_CREATE: 'api2.admin.promocodescontroller.create',
    PROMOCODES_SHOW: 'api2.admin.promocodescontroller.show',
    REPORTS_DOWNLOAD_REPORT: 'api2.admin.reportscontroller.download_report',
    REPORTS_GENERATE_REPORT: 'api2.admin.reportscontroller.generate_report',
    REPORTS_STUCTURE_STATES: 'api2.admin.reportscontroller.stucture_states',
    REQUESTS_ALL: 'api2.admin.requestscontroller.all',
    ROLES_CREATE: 'api2.admin.rolescontroller.create',
    STATICPAGES_COMMISSION: 'api2.admin.staticpagescontroller.commission',
    STATICPAGES_FAQ: 'api2.admin.staticpagescontroller.faq',
    STATICPAGES_HELP: 'api2.admin.staticpagescontroller.help',
    STATICPAGES_PRIVACY: 'api2.admin.staticpagescontroller.privacy',
    STATICPAGES_STATIC_PAGE_1: 'api2.admin.staticpagescontroller.static_page_1',
    STATICPAGES_STATIC_PAGE_2: 'api2.admin.staticpagescontroller.static_page_2',
    STATICPAGES_STATIC_PAGE_3: 'api2.admin.staticpagescontroller.static_page_3',
    STATICPAGES_STATIC_PAGE_4: 'api2.admin.staticpagescontroller.static_page_4',
    STATICPAGES_STATIC_PAGE_5: 'api2.admin.staticpagescontroller.static_page_5',
    STATICPAGES_TERMS: 'api2.admin.staticpagescontroller.terms',
    SUBAFFILIATECONDITIONS_DELETE: 'api2.admin.subaffiliateconditionscontroller.delete',
    SUBAFFILIATECONDITIONS_EDIT: 'api2.admin.subaffiliateconditionscontroller.edit',
    SUBAFFILIATECONDITIONS_SHOW: 'api2.admin.subaffiliateconditionscontroller.show',
    SUBAFFILIATEREPORTS_DOWNLOAD_REPORT: 'api2.admin.subaffiliatereportscontroller.download_report',
    SUBAFFILIATEREPORTS_GENERATE_REPORT: 'api2.admin.subaffiliatereportscontroller.generate_report',
    TRACKERS_DOWNLOAD_LIST: 'api2.admin.trackerscontroller.download_list',
    TRACKERS_SHOW: 'api2.admin.trackerscontroller.show',
    TRANSLATEMANAGER_EDIT: 'api2.admin.translatemanagercontroller.edit',
    TWO_FACTOR_AUTH: 'api2.admin.profilecontroller.two_factor_auth',
    TABLE_COLUMNS_SETTINGS: 'api2.admin.tablefordisplayscontroller.show',
    TABLE_COLUMNS_SETTINGS_VERSIONS: 'api2.admin.tablefordisplayscontroller.show_versions',
    TABLE_COLUMNS_SETTINGS_EDIT: 'api2.admin.tablecolumnsfordisplayscontroller.edit',
    MERCHANT_SETTINGS_SHOW: 'api2.admin.merchantscontroller.show',
    MERCHANT_SETTINGS_EDIT: 'api2.admin.merchantscontroller.edit',
    WELCOME_PAGE_REDIRECTS_SHOW: 'api2.admin.welcomepageredirectscontroller.show',
    WELCOME_PAGE_REDIRECTS_EDIT: 'api2.admin.welcomepageredirectscontroller.edit',
  },
  affiliate: {
    APITOKENSREFRESH_EDIT: 'api2.affiliate.apitokensrefreshcontroller.edit',
    APITOKENSREFRESH_SHOW: 'api2.affiliate.apitokensrefreshcontroller.show',
    ARTICLES_SHOW: 'api2.affiliate.articlescontroller.show',
    BACKGROUNDREPORTS_EDIT: 'api2.affiliate.backgroundreportscontroller.edit',
    BACKGROUNDREPORTS_SHOW: 'api2.affiliate.backgroundreportscontroller.show',
    BANNERS_LIST: 'api2.affiliate.bannerscontroller.list',
    BOOKKEEPINGS_DOWNLOAD_REPORT: 'api2.affiliate.bookkeepingscontroller.download_report',
    BOOKKEEPINGS_SHOW: 'api2.affiliate.bookkeepingscontroller.show',
    CASHOUTS_DOWNLOAD_REPORT: 'api2.affiliate.cashoutscontroller.download_report',
    CASHOUTS_LIST: 'api2.affiliate.cashoutscontroller.list',
    CASHOUTS_SHOW_BALANCE: 'api2.affiliate.cashoutscontroller.show_balance',
    CASHOUTS_WITHDRAW: 'api2.affiliate.cashoutscontroller.withdraw',
    COUNTRIES_LIST: 'api2.affiliate.countriescontroller.list',
    CREATIVEREPORTS_DOWNLOAD_REPORT: 'api2.affiliate.creativereportscontroller.download_report',
    CREATIVEREPORTS_GENERATE_REPORT: 'api2.affiliate.creativereportscontroller.generate_report',
    CREATIVES_SHOW: 'api2.affiliate.creativescontroller.show',
    DASHBOARD_CHART: 'api2.affiliate.dashboardcontroller.chart',
    DASHBOARD_GET_STATS: 'api2.affiliate.dashboardcontroller.get_stats',
    DASHBOARD_LAST_UPDATE: 'api2.affiliate.dashboardcontroller.last_update',
    DASHBOARD_PERSONAL_CHIEF: 'api2.affiliate.dashboardcontroller.personal_chief',
    DASHBOARD_PLAYERS_CHECK: 'api2.affiliate.dashboardcontroller.players_check',
    FILTERSETS_SHOW: 'api2.affiliate.filtersetscontroller.show',
    GETCREATIVELINKS_GET_LINK: 'api2.affiliate.getcreativelinkscontroller.get_link',
    PAYMENTSYSTEMS_SHOW: 'api2.affiliate.paymentsystemscontroller.show',
    PAYMENTSYSTEMS_UPDATE: 'api2.affiliate.paymentsystemscontroller.update',
    PAYMENTSYSTEMS_CREATE: 'api2.affiliate.paymentsystemscontroller.create',
    REPORTS_DOWNLOAD_REPORT: 'api2.affiliate.reportscontroller.download_report',
    REPORTS_GENERATE_REPORT: 'api2.affiliate.reportscontroller.generate_report',
    REPORTS_STUCTURE_STATES: 'api2.affiliate.reportscontroller.stucture_states',
    REQUESTS_DOWNLOAD_REPORT: 'api2.affiliate.requestscontroller.download_report',
    REQUESTS_SHOW: 'api2.affiliate.requestscontroller.show',
    SETTINGS_API_STATS: 'api2.affiliate.settingscontroller.api_stats',
    SETTINGS_EDIT: 'api2.affiliate.settingscontroller.edit',
    SETTINGS_REFERRALS_TOKEN: 'api2.affiliate.settingscontroller.referrals_token',
    SETTINGS_SHOW: 'api2.affiliate.settingscontroller.show',
    STATICPAGES_COMMISSION: 'api2.affiliate.staticpagescontroller.commission',
    STATICPAGES_FAQ: 'api2.affiliate.staticpagescontroller.faq',
    STATICPAGES_HELP: 'api2.affiliate.staticpagescontroller.help',
    STATICPAGES_PRIVACY: 'api2.affiliate.staticpagescontroller.privacy',
    STATICPAGES_STATIC_PAGE_1: 'api2.affiliate.staticpagescontroller.static_page_1',
    STATICPAGES_STATIC_PAGE_2: 'api2.affiliate.staticpagescontroller.static_page_2',
    STATICPAGES_STATIC_PAGE_3: 'api2.affiliate.staticpagescontroller.static_page_3',
    STATICPAGES_STATIC_PAGE_4: 'api2.affiliate.staticpagescontroller.static_page_4',
    STATICPAGES_STATIC_PAGE_5: 'api2.affiliate.staticpagescontroller.static_page_5',
    STATICPAGES_TERMS: 'api2.affiliate.staticpagescontroller.terms',
    SUBAFFILIATEREPORTS_DOWNLOAD_REPORT: 'api2.affiliate.subaffiliatereportscontroller.download_report',
    SUBAFFILIATEREPORTS_GENERATE_REPORT: 'api2.affiliate.subaffiliatereportscontroller.generate_report',
    TRACKERS_CREATE: 'api2.affiliate.trackerscontroller.create',
    TRACKERS_EDIT: 'api2.affiliate.trackerscontroller.edit',
    TRACKERS_SHOW: 'api2.affiliate.trackerscontroller.show',
    WEBHOOKS_ALL: 'api2.affiliate.webhookscontroller.all',
    TWO_FACTOR_AUTH: 'api2.affiliate.settingscontroller.two_factor_auth',
  },
  anonymous: {
    REGISTER: 'api2.anonym.registrationscontroller.create',
    STATICPAGES_TERMS: 'api2.anonym.staticpagescontroller.terms',
    STATICPAGES_PRIVACY: 'api2.anonym.staticpagescontroller.privacy',
  },
} as const;
